import React from 'react'
import Box from '@mui/material/Box'
import { Text } from '@mxenabled/mxui'

import { fromUnixToDayOfWeekAndDate } from '../../core/utils/DateUtil'

interface DateRowProps {
  date: number
}

const DateRow: React.FC<DateRowProps> = ({ date }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 12, py: 8 }}>
      <Text bold={true} variant="body2">
        {fromUnixToDayOfWeekAndDate(date)}
      </Text>
    </Box>
  )
}

export default DateRow
